import { create } from 'zustand';

interface AdminAssignmentDetailsStore {
  recipientSelection: { [key: string]: boolean };
  setRecipientSelection: (recipientSelection: { [key: string]: boolean }) => void;
}

export const useAdminAssignmentDetailsStore = create<AdminAssignmentDetailsStore>((set) => ({
  recipientSelection: {},
  setRecipientSelection: (recipientSelection) => set({ recipientSelection }),
}));
